import {
  Layout,
  Main,
  MainMobile,
  MobileLayout,
  Nav,
  NavMobile
} from './termsMigratedLayoutStyled';

import { globalImages } from '../../styles/GlobalStyles';

const TermsMigratedLayout = ({ children }: any) => {
  return (
    <>
      <Layout>
        <Nav>
          <img src={globalImages.authLayoutLogo} alt='logo' />
        </Nav>
        <Main>{children}</Main>
      </Layout>
      <MobileLayout>
        <NavMobile>
          <img src={globalImages.authLayoutLogo} alt='logo' />
        </NavMobile>

        <MainMobile>{children}</MainMobile>
      </MobileLayout>
    </>
  );
};

export default TermsMigratedLayout;
